// extracted by mini-css-extract-plugin
export default {"container":"LoadingScreen_container__BGXYf","text":"LoadingScreen_text__pg-uz","spinner":"LoadingScreen_spinner__GN3cq","lds-roller":"LoadingScreen_lds-roller__NLpeF"};